import { SHOW_ERROR, CLEAR_ERROR } from './errorActions';


const initMessage = localStorage.getItem('message');
const initErrType = localStorage.getItem('errType');
const initIp = localStorage.getItem('ip');
const initCountry = localStorage.getItem('country');

const initialState = {
  message: initMessage || '',
  errType: initErrType || null,
  ip: initIp || '',
  country: initCountry || '',
};

export default function errorReducer(state = initialState, action) {
  switch (action.type) {
    case SHOW_ERROR: {
      const message = action.payload?.message ?? '';
      const errType = action.payload?.errType ?? null;
      const ip = action.payload?.ip ?? '';
      const country = action.payload?.country ?? '';
      try {
        if (errType) {
          localStorage.setItem('errType', errType);
        } else {
          localStorage.removeItem('errType');
        }
        localStorage.setItem('message', message);
        localStorage.setItem('ip', ip);
        localStorage.setItem('country', country);
      } catch (e) {
        // ignore storage errors
      }

      return {
        ...state,
        errType,
        message,
        ip,
        country,
      };
    }
    case CLEAR_ERROR: {
      try {
        localStorage.removeItem('message');
        localStorage.removeItem('errType');
        localStorage.removeItem('ip');
        localStorage.removeItem('country');
      } catch (e) {
        // ignore storage errors
      }
      return {
        message: '',
        errType: null,
        ip: '',
        country: '',
      };
    }
    default:
      return state;
  }
}